import { cn, createComponent } from '@lair-finance/util'

export type TouchableButtonProps<T extends React.ElementType> = {
  as?: T
} & (T extends 'button'
  ? React.ButtonHTMLAttributes<HTMLButtonElement>
  : T extends 'a'
    ? React.AnchorHTMLAttributes<HTMLAnchorElement>
    : React.HTMLAttributes<HTMLElement>) & {
    size?: number
  }

export const TouchableButton = createComponent<HTMLElement, TouchableButtonProps<React.ElementType>>(
  ({ size, as: Component = 'button', className, ...props }, ref) => (
    <Component className={cn('inline-flex-center', className)} style={{ width: size, height: size }} ref={ref} {...props} />
  ),
  'TouchableButton',
)
